import React from 'react';
import Card from '../components/card';
import RadioButtons from '../components/RadioButtons';
import { BorrowerCard, CoborrowerCard } from './card-lenses';

const FirstTimeBuyer = ({ model, onChange, ...cardProps }) => {
  const value = model.get('firstTimeBuyer');
  return (
    <Card {...cardProps}>
      <RadioButtons
        name="firstTimeBuyer"
        value={value == null ? null : value.toString()}
        onChange={(value) => onChange('firstTimeBuyer', value === 'true')}
        choices={[
          { value: 'false', label: 'Yes' },
          { value: 'true', label: 'No' }
        ]}
      />
    </Card>
  );
};

FirstTimeBuyer.completed = ({ model }) => model.get('firstTimeBuyer') != null;

const BorrowerFirstTimeBuyer = BorrowerCard(FirstTimeBuyer, 'BorrowerFirstTimeBuyer', {
  title: 'Have you ever owned a home before?'
});

const CoborrowerFirstTimeBuyer = CoborrowerCard(FirstTimeBuyer, 'CoborrowerFirstTimeBuyer', {
  title: 'Has your co-borrower ever owned a home before?'
});

export { BorrowerFirstTimeBuyer, CoborrowerFirstTimeBuyer };



// WEBPACK FOOTER //
// ./src/cards/first-time-buyer.js